export function hasInvalidCharOrUmlat(value) {
  return /[\u0080-\u2018\u2020-\uFFFF|]/.test(value)
}

export function isAllowChar(char) {
  return /[\u0000-\u007A]/.test(char) // eslint-disable-line
}

function isUmlat(char) {
  return 'ŠŒŽšœžŸ¥µÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýÿ£€’'.indexOf(char) >= 0
}

function convertUmlat(umlatChar) {
  if (umlatChar === 'å') {
    return 'aa'
  } else if (umlatChar === 'Å') {
    return 'Aa'
  } else if (umlatChar === 'ø') {
    return 'oe'
  } else if (umlatChar === 'Ø') {
    return 'Oe'
  } else if (umlatChar === 'œ') {
    return 'ae'
  } else if (umlatChar === 'Œ') {
    return 'Ae'
  } else {
    const umlatIndex = 'ŠŒŽšœžŸ¥µÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýÿ£€’'.indexOf(umlatChar)
    return 'SOZsozYYuAAAAAAACEEEEIIIIDNOOOOOOUUUUYsaaaaaaaceeeeiiiionoooooouuuuyy£€\''[umlatIndex]
  }
}

export function convertAllUmlats(value) {
  let newValue = ''
  for (const char of value) {
    if (isAllowChar(char)) {
      newValue += char
    } else if (isUmlat(char)) {
      newValue += convertUmlat(char)
    }
  }
  return newValue
}

export function removeCyrillic(value) {
  return value.replace(/[а-яА-ЯёЁ]/g, '')
}

export function normalizeTextAnswer(answer) {
  let result = null
  const value = answer.value
  if (hasInvalidCharOrUmlat(value)) {
    const selectionStart = answer.selectionStart
    const selectionEnd = answer.selectionEnd
    let correctCaretPosition = 0
    let newValue = ''
    for (let i = 0; i < value.length; i++) {
      const char = value.charAt(i)
      if (isAllowChar(char) || isUmlat(char)) {
        newValue += char
      } else {
        result = result || 0
        correctCaretPosition = -1
      }
    }
    answer.value = newValue.trim()
    answer.selectionStart = selectionStart + correctCaretPosition
    answer.selectionEnd = selectionEnd + correctCaretPosition
  }
  return result
}

export function normalizeText(value) {
  let newValue = ''
  for (let i = 0; i < value.length; i++) {
    const char = value.charAt(i)
    if (isAllowChar(char) || isUmlat(char)) {
      newValue += char
    }
  }
  return newValue
}

const ICON_TYPES = {
  jpg: 'img',
  jpeg: 'img',
  png: 'img',
  gif: 'img',
  bmp: 'img',
  doc: 'doc',
  docx: 'doc',
  odt: 'doc',
  xls: 'xls',
  xlsx: 'xls',
  ods: 'xls',
  pdf: 'pdf',
  csv: 'csv'
}

export function tfxFileTypeIcon(file) {
  if (file) {
    const extension = file.split('.').pop(-1)
    if (!extension) return 'document-all'
    const commonType = ICON_TYPES[extension.toLowerCase()]
    return commonType ? `document-${commonType}` : 'document-all'
  } else {
    return 'document-all'
  }
}

export function empty(value) {
  return value === null || value === undefined || value.length === 0 || value === {}
}

export function present(value) {
  return !empty(value)
}
